import { ModuleWithProviders, NgModule } from '@angular/core';

import { ElSharedModule } from '../../shared/shared.module';
import { ElA11yModule } from '../a11y/a11y.module';
import { ElCdkMappingModule } from './mapping';
import { ElPositionBuilderService } from './overlay-position';
import { ElOverlayContainerComponent } from './overlay-container';
import { ElOverlayService } from './overlay-service';
import { ElCdkAdapterModule } from '../adapter/adapter.module';
import { ElPositionHelper } from './position-helper';
import { ElTriggerStrategyBuilderService } from './overlay-trigger';


@NgModule({
  imports: [
    ElCdkMappingModule,
    ElSharedModule,
  ],
  declarations: [ElOverlayContainerComponent],
  exports: [
    ElCdkMappingModule,
    ElCdkAdapterModule,
    ElOverlayContainerComponent,
  ],
})
export class ElOverlayModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders> {
      ngModule: ElOverlayModule,
      providers: [
        ElPositionBuilderService,
        ElTriggerStrategyBuilderService,
        ElOverlayService,
        ElPositionHelper,
        ...ElCdkMappingModule.forRoot().providers,
        ...ElCdkAdapterModule.forRoot().providers,
        ...ElA11yModule.forRoot().providers,
      ],
    };
  }
}
